import { useMemo } from 'react';
import { getOrganizationType } from 'lib/organizationType';
import { getTerminology } from 'constants/terminology';

export function useTerminology() {
  const organizationType = getOrganizationType();

  const terminology = useMemo(() => {
    return getTerminology(organizationType);
  }, [organizationType]);

  return terminology;
}
